import { useCallback, useMemo } from 'react';
import { PlaningViewsEnum } from 'components/common/PlanYourTrip/constants';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useAnalytics } from 'util/analytics';
import { Button } from 'components/blocks/Button';
import { ReactComponent as RecommendIcon } from 'public/assets/icons/recommend.svg';
import { ContextKey } from 'components/common/PlanYourTrip/types';

import { patnerTypes } from './partnerTypes';

import styles from './styles.module.scss';

interface IPartnerBlockProps {
  partnerLinkUrl?: string
  partnerType: PlaningViewsEnum.rental | PlaningViewsEnum.lessons
  title: string,
  country?: string
  /**
   * resort ore region, used for appropriate translation,
   */
  contextKey: ContextKey,
}

const PartnerBlock = ({
  partnerLinkUrl,
  partnerType,
  title,
  contextKey = 'resort',
}: IPartnerBlockProps) => {
  const { t } = useOTSTranslation('common');
  const analitics = useAnalytics();

  const { icon, header, analiticType } = useMemo(() => patnerTypes[partnerType], [partnerType]);
  const benefits = patnerTypes[partnerType].benefits as Array<I18nKeyGenerated['common']>;

  const onSearchClick = useCallback(() => {
    analitics.subcriberEvent(analiticType, { url: partnerLinkUrl });

    window.open(partnerLinkUrl, '_blank');
  }, [analitics, partnerLinkUrl]);

  return (
    <div className={styles.partnerLayout}>
      <div className={styles.iconBlock}>{icon}</div>
      <div className={styles.partnerInfoBlock}>
        <div className={styles.recommend}>
          <RecommendIcon />
          <span>{t('tripWidget.partnerLabel', { [contextKey]: title })}</span>
        </div>
        <h3>{t(header as I18nKeyGenerated['common'], { [contextKey]: title })}</h3>
        <ul>{benefits.map((i) => <li key={i}>{t(i)}</li>)}</ul>
        <Button className={styles.searchButton} onClick={onSearchClick}>
          {t('tripWidget.searchOffers')}
        </Button>
      </div>
    </div>
  );
};

export default PartnerBlock;
